import Vuex, { GetterTree, ActionTree, MutationTree, Action } from 'vuex';

interface MapStationList {
  loading: boolean;
  infos: Array<{ [key: string]: any }>;
}
interface MapSysList {
  loading: boolean;
  infos: Array<{ [key: string]: any }>;
}
interface MapCourseList {
  loading: boolean;
  infos: Array<{ [key: string]: any }>;
}
interface MapCourseStatus {
  loading: boolean;
  infos: Array<{ [key: string]: any }>;
}
interface MapUserSetting {
  loading: boolean;
  infos: Array<{ [key: string]: any }>;
}
interface SetMapUserSetting {
  loading: boolean;
  infos: Array<{ [key: string]: any }>;
}
interface StudyMapimport {
  loading: boolean;
  infos: Array<{ [key: string]: any }>;
}



export interface IState {
  [key: string]: any;
}

export const state: IState = {
  mapSys: {
    loading: false,
    infos: []
  } as MapSysList,
  mapStation: {
    loading: false,
    infos: []
  } as MapStationList,
  mapCourseList: {
    loading: false,
    courseSummry:{},
    infos: []
  } as MapCourseList,
  mapCourseStatus: {
    loading: false,
    courseSummry:{},
    infos: []
  } as MapCourseStatus,
  mapUserSetting: {
    loading: false,
    infos: []
  } as MapUserSetting,
  setMapUserSetting: {
    loading: false,
    infos: []
  } as SetMapUserSetting,
  studyMapimport:{
    loading:false,
    infos:[]
  } as StudyMapimport
};

// tslint:disable-next-line:ban-types
export const getters: GetterTree<IState, Function> = {
  mapStation: (myState: IState) => myState.mapStation,
  mapSys: (myState: IState) => myState.mapSys,
  mapCourseList: (myState: IState) => myState.mapCourseList,
  mapCourseStatus: (myState: IState) => myState.mapCourseStatus,
  mapUserSetting: (myState: IState) => myState.mapUserSetting,
  setMapUserSetting: (myState: IState) => myState.setMapUserSetting,
  studyMapimport: (myState: IState) => myState.StudyMapimport,
};
